/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.support.portal.rpc.ThreadViewRpc
 */
import * as References from './ThreadViewRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import portalsHttpClient from 'portals-platform-lib/portalsHttpClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: portalsHttpClient
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.support.portal.rpc.ThreadViewRpc#getRelevantThreadsForUser
 */
export const GET_RELEVANT_THREADS_FOR_USER_QUERY_FIELD_NAME = 'com_hubspot_support_portal_rpc_ThreadViewRpc_getRelevantThreadsForUser';
export const GET_RELEVANT_THREADS_FOR_USER_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_RELEVANT_THREADS_FOR_USER_QUERY_FIELD_NAME,
  args: ['params', 'accountId', 'membershipToken', 'utkCookie', 'portalInstanceId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getRelevantThreadsForUserRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.support.portal.rpc.ThreadViewRpc#getThreadView
 */
export const GET_THREAD_VIEW_QUERY_FIELD_NAME = 'com_hubspot_support_portal_rpc_ThreadViewRpc_getThreadView';
export const GET_THREAD_VIEW_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_THREAD_VIEW_QUERY_FIELD_NAME,
  args: ['params', 'accountId', 'membershipToken', 'utkCookie', 'portalInstanceId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getThreadViewRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});